
import { WizardStep } from "@/types/enums.type";
import { Component, Mixins } from "vue-property-decorator";
import WizardMixin from "../wizard.mixin";

@Component
export default class WizardWelcomeComponent extends Mixins(WizardMixin) {
  WizardStep = WizardStep;
}
